routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.reportRemission', {
      url: "reportes/remisiones",
      template: `<report-remission sh-ctrl="shCtrl"></report-remission>`
    });
}

export default routesConfig;


/** WEBPACK FOOTER **
 ** ./www/components/reports/remission/remission.config.js
 **/